import { useEffect, Suspense, lazy } from 'react'
import posthog from 'posthog-js'

// Contextos
import { ThemeProvider } from './contexts/ThemeContext'

// Apps por subdomain
const AdminApp = lazy(() => import('./AdminApp'))
const PanelApp = lazy(() => import('./PanelApp'))
const PublicApp = lazy(() => import('./PublicApp'))

// Utils
import { isPanelSubdomain, isDashAdminSubdomain } from './utils/subdomain'

/**
 * App principal que enruta basado en subdomain
 * - dash.admin.vitriventa.com → AdminApp (panel super admin) ← NUEVO
 * - panel.vitriventa.com → PanelApp (dashboard de vendedores)
 * - vitriventa.com → PublicApp (sitio público + tiendas)
 */
function App() {
  useEffect(() => {
    // Configurar PostHog
    if (import.meta.env.VITE_POSTHOG_API_KEY) {
      posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
        api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        loaded: (posthog) => {
          if (import.meta.env.DEV) posthog.debug() // debug mode en desarrollo
        }
      })
    }
  }, [])

  const isDashAdmin = isDashAdminSubdomain()
  const isPanel = isPanelSubdomain()

  return (
    <ThemeProvider>
      <Suspense
        fallback={
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-50 dark:bg-gray-950">
            <span className="loader mx-auto mb-4" />
          </div>
        }
      >
        {isDashAdmin ? (
          <AdminApp />
        ) : isPanel ? (
          <PanelApp />
        ) : (
          <PublicApp />
        )}
      </Suspense>
    </ThemeProvider>
  )
}

export default App
